import sortEvents from '@/lib/activityEvents/sortPieveActivityEvents.js';
import getWorkspaceName from '@/lib/threads/getThreadWorkspaceName.js';
import sharedComposer from '@/redux/reducers/pieveReducer/sharedComposer.js';

/* `eventsHydrated` marks the difference between "no events fetched yet" (the shell starts with an empty
   activity) and "fetched"; once true it stays true. */
const buildThreadContentShell = ({ thread = null, threadId = null, existingContent = null, activity = null, runState = null, eventsHydrated = false } = {}) => {
  const normalizedThreadId = String(threadId || thread?.id || existingContent?.threadId || '').trim();

  if (!normalizedThreadId) {
    return null;
  }

  return {
    threadId: normalizedThreadId,
    header: {
      title: thread?.title || existingContent?.header?.title || 'New task',
      workspace: thread ? getWorkspaceName([thread]) : existingContent?.header?.workspace || 'Workspace',
      additions: existingContent?.header?.additions || 0,
      deletions: existingContent?.header?.deletions || 0,
      threadTotalCostUsd: Object.prototype.hasOwnProperty.call(thread || {}, 'threadTotalCostUsd') ? thread.threadTotalCostUsd : (existingContent?.header?.threadTotalCostUsd ?? null)
    },
    diffCard: existingContent?.diffCard || null,
    filePreview: existingContent?.filePreview || null,
    contextWindowUsage: existingContent?.contextWindowUsage || thread?.contextWindowUsage || null,
    activity: sortEvents(Array.isArray(activity) ? activity : existingContent?.activity || []),
    appConnections: Array.isArray(existingContent?.appConnections) ? existingContent.appConnections : [],
    ...(eventsHydrated || existingContent?.eventsHydrated ? { eventsHydrated: true } : {}),
    runState: runState || existingContent?.runState || thread?.runState || { state: 'idle', runId: null },
    composer: {
      ...sharedComposer,
      ...(existingContent?.composer || {})
    },
    ...(existingContent?.webSearch ? { webSearch: existingContent.webSearch } : {})
  };
};

export default buildThreadContentShell;
